import script from "./QueryGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryGuide.vue?vue&type=script&setup=true&lang=js"

import "./QueryGuide.vue?vue&type=style&index=0&id=0db04cd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db04cd8"]])

export default __exports__